import React, {useEffect, useState} from "react";
import Education from "./educations";
import Works from "./works";
import {useHistory} from "react-router-dom";
import useUserInfo from "../../routers/useUserInfo";
import {ResumeData} from "../types";
import {getUserResumesInfo} from "../../service";
import {sexTsf} from "../../units";
import {useModal} from "../../components/modal";
import {useDispatch} from "react-redux";
import {userSkill} from "../../store/actions";

const list = ['中国地区','港澳台地区','其他国家']

function Resume() {

    const userData = useUserInfo(false)
    const modal = useModal()
    const [info,setInfo] = useState<ResumeData>()
    const { push , goBack} = useHistory()
    const dispatch = useDispatch()


    useEffect(() =>{
        if(userData){
            getUserResumesInfo({
                userId:userData.id
            }).then(res => {
                if(res.code === 1){
                    setInfo(res.data)
                    dispatch(userSkill(res.data.skill))
                }
            })
        }else{
            modal.show({
                content:'该功能需要用户登录，是否继续?',
                confirmText:'用户登陆',
                cancelText:'取消浏览',
                success(res){
                    if (res.confirm){
                        push('/login')
                    }else{
                        goBack()
                    }
                }
            })
        }
    },[])

    return <div className="resume-page">
        <div className="box1">
            <div className="left" onClick={ () =>  push('/user/resume/userinfo')}>
                <h3>{ info?.fullName ||  '姓名'} <span className="iconfont">&#xe613;</span> </h3>
                <p className="s">{ sexTsf(info?.sex) || '选择性别' }</p>
                <p className="s">
                    <span>{ info?.birthday || '选择生日' }</span>
                    <span>{ info?.region ? list[info.region] : '选择地区' }</span>
                </p>
            </div>
            <div className="right">
                <div className="img" style={{ backgroundImage:`url(${ info?.photo })` }} onClick={() => push('/user/info/resume/photo')}>
                    {
                        !info?.photo && <div className="no-phone">
                            <p className="iconfont">&#xe64b;</p>
                            {/*<p>简历照片</p>*/}
                        </div>
                    }

                </div>
            </div>
        </div>
        <div className="box2">
            <h3>个人优势<span className="iconfont" onClick={ () => push('/user/info/resume/skill') }>&#xe613;</span> </h3>
            <div className="detail">
                {
                    info?.skill ? <p className="skill">{ info.skill }</p> : <p className="no-skill">您还未填写个人优势~~</p>
                }

            </div>
        </div>
        {
            userData && <>
                <div className="box3">
                    <Education/>
                </div>
                <div className="box4">
                    <Works/>
                </div>
            </>
        }
    </div>
}

export default Resume;
